import { optional } from '@/helpers/dto2resource';
import AcordoExternoDto from '../dto/AcordoExternoDto';
import DetalheDividaDto from '../dto/DetalheDividaDto';
import DividaParametros from '../dto/DividaParametros';
import { IDivida } from '../IDivida';
import ComposicaoDividaResource from './ComposicaoDividaResource';

export default class DividaAcordoExternoResource implements IDivida {
  id: number;
  dataOrigem: Date;
  valorVencido?: number;
  valorVincendo?: number;
  codigoCredor: number;
  produto?: string;
  codigoContrato: string | null;
  descricao: string | null;
  dataChegada?: Date;
  valorPrincipal?: number | null;
  valorTotal?: number | null;
  valorAcrescimos?: number | null;
  credor: string;
  api: string;
  detalhe?: DetalheDividaDto | null;
  interface: string;
  parametros?: DividaParametros;
  composicao: ComposicaoDividaResource[];
  fluxoNegociacao?: string | null;

  constructor(api: string, dto: AcordoExternoDto) {
    this.id = dto.id;
    this.dataOrigem = new Date(dto.divida.dataOrigem);
    this.valorPrincipal = optional(dto.divida.valorVincendo + dto.divida.valorVencido);

    this.valorTotal = dto.valorEntrada
      + dto.valorParcela * dto.quantidadeParcelas;
    this.valorAcrescimos = optional(dto.divida.valorJuros + dto.divida.valorMulta);
    this.valorVencido = optional(dto.divida.valorVencido);
    this.valorVincendo = optional(dto.divida.valorVincendo);

    this.credor = api.startsWith('mc-') ? api.slice(3) : api;
    this.api = api;
    this.produto = dto.divida.produto;
    this.produto = dto.divida.produto || undefined;

    this.codigoCredor = dto.divida.codigoCredor;
    this.codigoContrato = dto.divida.codigoContrato;

    this.descricao = null;
    this.interface = api.replace(/^mc-/, '');

    this.composicao = [];
  }

  get ofuscada(): boolean {
    return !!this.parametros?.requerAutenticacao2FA;
  }

  get contratos() {
    return this.codigoContrato
      ? [this.codigoContrato]
      : this.composicao
        .filter((comp) => comp.codigoContrato)
        .map((comp) => comp.codigoContrato);
  }

  get possuiSincronizacaoParcela(): boolean {
    if (this.parametros?.possuiSincronizacaoParcela === undefined) {
      return true;
    }
    return !!this.parametros?.possuiSincronizacaoParcela;
  }

  get possuiComposicao(): boolean {
    return this.composicao.length > 1;
  }

  get permitePagamentoAposVencimento() {
    return !this.parametros || this.parametros.permitePagamentoAposVencimento;
  }

  get logo(): string {
    return this.detalhe?.logo || this.api;
  }

}
